import {setSearch} from '../components/search.js';
import {setMenu, setContextMenu} from '../components/navigation.js';

const body = document.body;
const openButton = document.querySelector('#mobile_navigation');

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && body.classList.contains('np-search-open')) {
    setSearch(false);
    document.querySelector('.srchButton')?.focus();
    return;
  }
  if (event.key === 'Escape' && body.classList.contains('np-menu-open')) {
    setMenu(false);
    openButton?.focus();
    return;
  }
  if (event.key === 'Escape' && body.classList.contains('np-context-menu-open')) {
    setContextMenu(false);
    document.querySelector('.np-context-toggle')?.focus();
  }
});
